<template>
  <div class="uk-card-body uk-text-center">
    <h2 class="uk-heading-small dcs-h2">We have received your request and will respond within 45 days.</h2>

    <a class="dcs-button uk-button uk-button-primary" href="/"
      >Return to Home Page</a
    >
  </div>
</template>

<script>
export default {
  name: "finish",
  props: ["requestType", "deliveryMethod"],
  computed: {
    requestTypeDisplay: function() {
      if (this.requestType == "removal") {
        return "deletion";
      } else {
        return this.requestType;
      }
    },
    deliveryMethodDisplay: function() {
      if (this.deliveryMethod == "email") {
        return "email";
      } else {
        return "mail";
      }
    }
  }
};
</script>

<style scoped></style>
